 $(document).ready(function () {

  
  // $('.unavailable.product-grid-item').hide();

  // $('input#filter-Disponibilité-2').prop("checked", false);

  // $("input#filter-Disponibilité-1").prop("checked", true);

  // $("input#filter-Availability-1").prop("checked", true);

  // $("input#filter-Availability-2").prop("checked", false);
  
 
$(document).on('change', '#filter-Disponibilité-2', function(e) {
    if ($(this).is(':checked')) {
       setTimeout(function() {
          $('.unavailable.product-grid-item').removeClass('hide').show();
          $('.product-grid-item:not(.unavailable)').addClass('hide').hide();
          console.log("out of stock is checked.");
        }, 2000);
    } 
});

$(document).on('change', '#filter-Disponibilité-1', function(e) {
    if ($(this).is(':checked')) {
       setTimeout(function() {
          $('.unavailable.product-grid-item').addClass('hide').hide();
          console.log("in stock is checked.");
        }, 2000);
    }
});

$(document).on('change', '#filter-Availability-1', function(e) {
    if ($(this).is(':checked')) {
       setTimeout(function() {
          $('.unavailable.product-grid-item').addClass('hide').hide();
          console.log("in stock is checked.");
        }, 2000);
    }
});

$(document).on('change', '#filter-Availability-2', function(e) {
    if ($(this).is(':checked')) {
        setTimeout(function() {
          $('.unavailable.product-grid-item').removeClass('hide').show();
          $('.product-grid-item:not(.unavailable)').addClass('hide').hide();
          console.log("out of stock is checked.");
        }, 2000);
    } 
});


  $('.close_filter').click(function(){
    console.log('registered');
  });

      $('.product-grid-item').mouseenter(function(){
        $(this).addClass('hover_colors');
       });
      $('.product-grid-item').mouseleave(function(){
         $(this).removeClass('hover_colors');
       });

      $('.filter__input').change(function() {
         if($('.collection__filters__clear').children().length > 0 ){
           console.log('test');
          $('.collection__products .grid').addClass('filtering');
          }
      });

        $('.filter_contain').click(function(){
          $('.collection__filters').toggleClass('opened');
        });

      var $firstimg = $('.step[data-step="1"]').attr('data-image');
      $('.image_box').css('background-image', 'url('+ $firstimg +')');

      $("#backtotop").click(function () {
         $("html, body").animate({scrollTop: 0}, 1000);
      });

       $(window).scroll(function() {    
          var scroll = $(window).scrollTop();
          if (scroll >= 500) {
              $("body.template-collection").addClass("has-scrolled", 2000);
          }else{
            $("body.template-collection").removeClass("has-scrolled", 2000);
          }
      });

      var lastScrollTop = 0;
      $(window).scroll(function(event){
         var st = $(this).scrollTop();
         if (st > lastScrollTop){
             $('#backtotop').addClass('view');
         } else {
            $('#backtotop').removeClass('view');
         }
         lastScrollTop = st;
      });
       $('.reset').click(function(){
          $('form')[0].reset();
       });

        var $faq_button = $('.faq-btn');
        var $close = $('#close_faqpopup');
        var $faq_popup = $('.faq_popup');
        var $faq_content = $('.faq_content');
      $faq_button.click(function(){
        $faq_popup.toggleClass('open');
      });
      $close.click(function(){
        $faq_popup.removeClass('open');
      });


    $(window).on("contextmenu",function(){
       return false;
    }); 
   

$('.pointer').each(function(){
  $(this).click(function(){
    var $pointerIndex = $(this).data('index');
    $('.look__slide').each(function(){
      if($(this).data('index') == $pointerIndex){
        $(this).addClass('focused');
      }else{
        $(this).removeClass('focused');
      }
    });
  });
});


$('.marquee_sale').marquee({
      allowCss3Support: true,
      css3easing: 'linear',
      easing: 'linear',
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      duration: 8000,
      gap: 20,
      pauseOnCycle: false,
      pauseOnHover: false,
      startVisible: false
});

$('.product-grid-item.variant').removeClass('hide');

function handleize(str) {
  return str
    .replace(/✕/g, '') // remove X first
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function refreshVariants() {

  //  let colorVariantArray = [];

  let colorVariantArray = JSON.parse(sessionStorage.getItem('selectedColors')) || [];


  $(document).on('click', '.collection__filter-tag--swatch', function () {
  const color = handleize($(this).find('label').attr('data-swatch'));

  if($(this).find('.swatch__input').checked){
      var index = $.inArray(color, colorVariantArray);

      if (index !== -1) {
          colorVariantArray.splice(index, 1); 
      }
  }else{
    if (!colorVariantArray.includes(color)) {
      colorVariantArray.push(color);
    }
    
    
  }
  
sessionStorage.setItem('selectedColors', JSON.stringify(colorVariantArray));

});




  const $elements = $('.product-grid-item.variant');

  if (colorVariantArray.length === 0) {
    $elements.removeClass('hide');
    return;
  }
 
  $elements.each(function () {
    const $item = $(this);

    const match = colorVariantArray.some(className =>
      $item.hasClass(className)
    );

    $item.toggleClass('hide', !match);
  });
 

}

// Initial load
sessionStorage.removeItem('selectedColors');
refreshVariants();




$(document).on('click', 'li.collection__filter-tag', function (event) {
  setTimeout(refreshVariants, 2000);
});



function verifyProductInventory(productHandle, targetColor, targetSize) {
    $.ajax({
        url: `/products/${productHandle}.js`,
        type: 'GET',
        dataType: 'json',
        success: function(product) {
            
            // 1. Locate the exact variant matching both the color and size strings
            let matchedVariant = product.variants.find(function(variant) {
                let options = variant.options.map(opt => opt.toLowerCase().trim());
                return options.includes(targetColor.toLowerCase().trim()) && 
                       options.includes(targetSize.toLowerCase().trim());
            });

            // 2. Perform the critical safety & stock validations
            if (!matchedVariant) {
                handleInventoryResult("NOT_FOUND", null);
            } 
  
            else if (matchedVariant.available === true) {
                handleInventoryResult("IN_STOCK", matchedVariant.id);
            } 
            else {
                handleInventoryResult("OUT_OF_STOCK", matchedVariant.id);
            }
        },
        error: function() {
            handleInventoryResult("NOT_FOUND", null);
        }
    });
}

function handleInventoryResult(status, variantId) {
    if (status === "IN_STOCK") {
      //  console.log(`✅ Success! This color and size combination is physically IN STOCK. ID: ${variantId}`);
        
    } else if (status === "OUT_OF_STOCK") {
      
      //console.warn(`⚠️ The size exists in the system, but it is currently OUT OF STOCK.`);
       
    } else {
     //   console.error(`❌ This color/size combination does not exist for this product.`);
    }
}




$(document).on('click', 'li.collection__filter-tag--default' , function(event){

      var sizeVal = $(this).children('input').val();
     // console.log(sizeVal);

      var hasSize = false;
      $('.product-grid-item').each(function (variant) {
        var colorVal = $(this).data('color');
        var productVal = $(this).data('product');
       // console.log(colorVal);
        verifyProductInventory(productVal, colorVal, sizeVal);
      
      });
 

});



// Remove filter
$(document).on('click', '.filter__active__remove', function () {
  setTimeout(refreshVariants, 2000);
});



  
});
     

